import { Modal } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { BiLoaderAlt } from "react-icons/bi";
import { updateQuote } from "../../stores/actions/quote.actions.types";
import { connect } from "react-redux";
import { errorMessage, successMessage } from "../../utilities/notification";

const QuoteStatusUpdate = ({ opened, setOpened, status, updateQuote, id, onSuccess }) => {
  const [updateLoading, setUpdateLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(status);

  useEffect(() => {
    setSelectedStatus(status);
  }, [status]);

  const handleUpdate = () => {
    setUpdateLoading(true);
    if (!selectedStatus) {
      return errorMessage("Select status");
    }

    const callback = (data) => {
      if (data.success) {
        successMessage("Quote status updated successfully!");
        setUpdateLoading(false);
        if (onSuccess) onSuccess();
        closeModal();
      } else {
        setUpdateLoading(false);
      }
    };
    updateQuote({ id, data: { status: selectedStatus }, callback });
  };

  const closeModal = () => {
    setUpdateLoading(false);
    setOpened(false);
  };

  return (
    <Modal
      centered
      opened={opened}
      onClose={() => closeModal()}
      title='Change Quote Status'
      overlayProps={{
        backgroundOpacity: 0.6,
        blur: 3,
      }}
    >
      <div className='my-8 text-center'>
        <h1 className='mb-10 text-xl font-semibold'>Change Quote Status</h1>
        <select
          value={selectedStatus}
          onChange={(e) => {
            setSelectedStatus(e.target.value);
          }}
          className={`relative z-10 w-full appearance-none rounded-[7px] border border-stroke bg-transparent py-2 pl-2 pr-8 outline-none transition focus:border-primary active:border-primary dark:border-dark-3 dark:bg-dark-2 sm:pr-12`}
        >
          <option
            value='pending'
            disabled={status === "pending"}
            className='text-black disabled:cursor-not-allowed disabled:text-gray-400 dark:text-dark-6'
          >
            Pending
          </option>
          <option
            value='contacted'
            disabled={status === "contacted"}
            className='text-black disabled:cursor-not-allowed disabled:text-gray-400 dark:text-dark-6'
          >
            Contacted
          </option>
          <option
            value='closed'
            disabled={status === "closed"}
            className='text-black disabled:cursor-not-allowed disabled:text-gray-400 dark:text-dark-6'
          >
            Closed
          </option>
        </select>
      </div>
      <div className='flex items-center justify-center space-x-4'>
        <button
          className='w-full rounded bg-red-500 px-4 py-2 text-white hover:bg-red-600'
          onClick={handleUpdate}
          disabled={updateLoading}
        >
          {updateLoading ? (
            <BiLoaderAlt className='m-auto animate-spin text-2xl' />
          ) : (
            "Update"
          )}
        </button>
        <button
          className='w-full rounded bg-gray-300 px-4 py-2 hover:bg-gray-400'
          onClick={closeModal}
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({ loading: state?.app?.visible });
export default connect(mapStateToProps, { updateQuote })(QuoteStatusUpdate);
